import * as moment from 'moment';

const DEBUG = true;

export default class QueryBuffer {

    private delay: number;
    private lastQuery: string | null;
    private lastQueryTime: any | null;
    private running: boolean;
    private queue: Array<Object>;
    public timerId: number | null;
    private itemsInserted: number;

    /**
     * Query buffer constructor
     * @param delay
     */
    public constructor(delay: number) {

        this.delay = delay;
        this.lastQuery = null;
        this.lastQueryTime = null;
        this.running = false;
        this.queue = [];
        this.timerId = null;
        this.lastQueryTime = moment();
        this.itemsInserted = 0;

        if (DEBUG) console.log("Query buffer initialized");
    }

    /**
     * Takes any object as payload and requires a callback that can be collect with the config
     *
     * @param query
     * @param callback
     */
    public insert(query: Object, callback: (query: Object) => void) {

        if (!this.isDuplicate(query)) {
            this.insertToQueue(query, callback);
        }
    }

    /**
     * Insert to the processing queue
     *
     * @param query
     * @param callback
     */
    private insertToQueue(query: Object, callback: (query: Object) => void) {

        this.queue.push(query);

        if (!this.timerId) {

            // Process first item immediately
            if (this.itemsInserted === 0) {
                this.processLastQueueItem(this, callback);
            }

            this.timerId = setInterval(this.processLastQueueItem, this.delay, this, callback);
        }

        this.itemsInserted++;
    }

    /**
     * Process last item from the queue
     *
     * @param buffer
     * @param callback
     */
    private processLastQueueItem(buffer: QueryBuffer, callback: (query: Object) => void) {

        if (buffer.queue.length > 0) {

            if (DEBUG) console.log("Queue contains " + buffer.queue.length + " items!");

            // Get copy of the last item in the queue
            const lastItem: Object|undefined = [...buffer.queue].pop();

            if (lastItem) {
                buffer.queue = [];
                buffer.lastQueryTime = moment();
                callback(lastItem);

                // Really remove item from queue
                buffer.queue.pop();
            }
        }
    }

    /**
     * Gets rid of any duplicates coming in
     *
     * @param query
     */
    private isDuplicate(query: Object): boolean {
        const newQuery = JSON.stringify(query);

        // Skip duplicates
        if (newQuery === this.lastQuery) {
            if (DEBUG) console.log("Skipped duplicate");
            return true;
        }

        this.lastQuery = newQuery;
        return false;
    }
}